<template>
  <van-swipe class="swipes" :show-indicators="showIndicators" :autoplay="3000" @change="onChange">
    <van-swipe-item v-for="(image, index) in banner" :key="index">
      <!-- <KImg
        class="pageBannarShadow pageBigRadius"
        :class="{unCurrent: index !== current}"
        :src="image.img_url"
        @click="toUrl(item.img_link)"
      />-->
      <div class="pageBannarShadow  kimg">
        <img
          :class="{unCurrent: index !== current}"
          :src="image"
        />
      </div>
    </van-swipe-item>
  </van-swipe>
</template>
 
<script>
/*global $ */
export default {
  props: {
    banner: {
      type: Array,
      default: () => [],
    },
    showIndicators:{
      type:Boolean,
      default:()=>false
    }
  },
  data() {
    return {
      current: 0,
    };
  },
  mounted() {},
  methods: {
    load(index) { 
      if (index + 1 == this.banner.length) { 
        this.$nextTick(() => {
          $(".footer").show();
          this.$store.commit("setPageLoading", false);          
        });
      }
    },
    toUrl() {      
      // if (val != "" && val != undefined&&val.IndexOf("http")<0) {
      //   this.$push({path:val});
      // }else{

      // }
    },
    Onclick(val) {
      if (val != "" && val != undefined) {
        location.href = val;
        
      }
    },
    onChange(index) {
      this.current = index;
    },
  },
};
</script>

<style scoped lang="less">
.swipes {
  transform: translateZ(0);
  .kimg {
    margin:0px;
    font-size: 0;
    background: initial;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .unCurrent {
    opacity: 0.5;
  }
}
</style>
